export const getTotalPrice = (hours: string, price: number): number => parseInt(hours, 10) * price;
